/**
 * FacetMenuBudget Component
 */

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { FormProps, reduxForm } from 'redux-form';

import { IQueryStringContext, QueryStringContext } from '../../../../contexts/queryString';
import { budgetFilterMaximum } from '../../../../contexts/queryString/budgetFilter';
import { getDefaultBudgetFilter, hasLicenseParams } from '../../../../contexts/queryString/selectors';
import { trackSetBudget } from '../../../../redux/actions/analytics';
import { FieldMoney } from '../../../../redux/form/utils';
import Button from '../../../atoms/buttons/Button';
import SessionLicenseBuilderButton from '../../../atoms/buttons/LicenseBuilderButton/SessionLicenseBuilderButton';
import TextField from '../../../atoms/forms/TextField';
import { IconTerms } from '../../../atoms/images/Icon';
import { Paragraph } from '../../../atoms/text/Label';

interface IOwnStateProps {
  initialValues: any;
}

interface IOwnProps {
  className?: string;
  currency: GQL.Currency;
  onOpenLicenseBuilder?: () => any;
  onCloseLicenseBuilder?: () => any;
}

interface IOwnDispatchProps {
  trackSetBudget: (budget: GQL.ITrackSearchBudgetFilter) => any;
}

interface IQueryStringContextProps extends Pick<IQueryStringContext, 'addBudgetFilter' | 'removeBudgetFilter'> {
  defaultValue: GQL.ITrackSearchBudgetFilter;
  hasValidLicense: boolean;
}

type FacetMenuBudgetProps =
  & IOwnProps
  & IOwnStateProps
  & FormProps<ISearchBudgetFilterActionPayload, {}, {}>;

const classes = new BEM('facet-menu');

class FacetMenuBudget extends React.Component<FacetMenuBudgetProps & IQueryStringContextProps & IOwnDispatchProps, {}> {
  onSubmit = ({ budget }: ISearchBudgetFilterActionPayload) => {
    let validBudget: GQL.ITrackSearchBudgetFilter | undefined = budget;

    if (budget) {
      if (!budget.minimum) {
        if (!budget.maximum) {
          validBudget = undefined;
        } else {
          validBudget = {
            minimum: 0,
            maximum: budget.maximum,
          };
        }
      } else {
        if (!budget.maximum) {
          validBudget = {
            minimum: budget.minimum,
            maximum: budgetFilterMaximum,
          };
        } else {
          validBudget = budget.minimum > budget.maximum ?
            {
              minimum: budget.maximum,
              maximum: budget.minimum,
            }
            : budget;
        }
      }
    }

    if (validBudget) {
      this.props.addBudgetFilter(validBudget);
      this.props.trackSetBudget(validBudget);
    } else {
      this.props.removeBudgetFilter();
    }
  }

  renderForm() {
    const {
      className,
      handleSubmit,
    } = this.props;

    const textfieldProps = {
      colorScheme: 'light',
      component: TextField,
      optional: true,
      size: 'small',
    };

    const extraClasses = classNames(className);

    return (
      <form {...classes('', 'budget', extraClasses) } onSubmit={handleSubmit!(this.onSubmit)}>
        {/* <FieldMoney
          name="budget[minimum]"
          placeholder="From"
          withoutBorder
          currency={this.props.currency}
          {...textfieldProps}
        /> */}
        {/* <Span className="range-separator" text="&mdash;" /> */}
        <Paragraph className="message--label" variant="description" size="xlarge">
          Please specify your maximum budget:
        </Paragraph>
        <FieldMoney
          name="budget[maximum]"
          placeholder="To"
          withoutBorder
          autoFocus
          currency={this.props.currency}
          {...textfieldProps}
        />
        <Button
          label="Set"
          variant="pill"
          size="small-medium"
          colorScheme="dark"
          isSubmit
        />
      </form>
    );
  }

  renderSetTerms() {
    const extraClasses = classNames(
      this.props.className,
      'without--license',
    );
    return (
      <div {...classes('', 'budget', extraClasses) }>
        <Paragraph className="message--no-terms-set" variant="description" size="xlarge">
          In order to filter by budget, you must first set your license terms.
        </Paragraph>
        <SessionLicenseBuilderButton
          label="Build Your License"
          colorScheme="accent"
          variant="pill"
          icon={<IconTerms />}
          onOpenLicenseBuilder={this.props.onOpenLicenseBuilder}
          onCloseLicenseBuilder={this.props.onCloseLicenseBuilder}
        />
      </div>
    );
  }

  render() {
    return this.props.hasValidLicense ? this.renderForm() : this.renderSetTerms();
  }
}

const ConnectedForm = reduxForm({
  form: 'budget-filter',
})(FacetMenuBudget);

const ConnectedFacetMenuBudget =
  connect<IOwnStateProps, IOwnDispatchProps, IOwnProps & IQueryStringContextProps, IStoreState>(
  (_, { defaultValue }) => ({
    initialValues: {
      budget: defaultValue,
    },
    }),
    (dispatch) => ({
      trackSetBudget: (budget: GQL.ITrackSearchBudgetFilter) => dispatch(trackSetBudget(budget)),
    }),
)(ConnectedForm);

const FacetMenuBudgetWithQueryStringContext: React.SFC<Pick<FacetMenuBudgetProps, keyof IOwnProps>> = (props) => (
  <QueryStringContext.Consumer>
    {(ctx) => (
      <ConnectedFacetMenuBudget
        addBudgetFilter={ctx.addBudgetFilter}
        defaultValue={getDefaultBudgetFilter(ctx)}
        hasValidLicense={hasLicenseParams(ctx)}
        removeBudgetFilter={ctx.removeBudgetFilter}
        {...props}
      />
    )}
  </QueryStringContext.Consumer>
);

export default FacetMenuBudgetWithQueryStringContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/search/FacetMenu/FacetMenuBudget.tsx